export default __webpack_public_path__ + "static/media/login-etf-banner.3dcfb6d7.svg";